import React from 'react';
import { Box, Container, Typography, Stack, Divider } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import PublicIcon from '@mui/icons-material/Public';
import StarIcon from '@mui/icons-material/Star';
import SportsIcon from '@mui/icons-material/Sports';

const stats = [
  { icon: <PeopleIcon sx={{ fontSize: 28, color: '#FFD700' }} />, value: '3 000+', label: 'entraîneurs' },
  { icon: <SportsIcon sx={{ fontSize: 28, color: '#FFD700' }} />, value: '100 000+', label: 'tactiques créées' },
  { icon: <PublicIcon sx={{ fontSize: 28, color: '#FFD700' }} />, value: '15+', label: 'pays' },
  { icon: <StarIcon sx={{ fontSize: 28, color: '#FFD700' }} />, value: '4.8 / 5', label: 'satisfaction client' },
];

export const TrustBar: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'rgba(0,0,0,0.85)',
        borderTop: '1px solid rgba(255,215,0,0.2)',
        borderBottom: '1px solid rgba(255,215,0,0.2)',
        py: { xs: 2.5, md: 2 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          divider={<Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.12)' }} />}
          spacing={{ xs: 2, sm: 0 }}
          alignItems="center"
          justifyContent="space-around"
        >
          {stats.map((stat, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: { sm: 3 },
                gap: 0.5,
              }}
            >
              <Stack direction="row" alignItems="center" gap={1}>
                {stat.icon}
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '1.4rem', md: '1.6rem' },
                    color: 'white',
                    lineHeight: 1,
                  }}
                >
                  {stat.value}
                </Typography>
              </Stack>
              <Typography
                sx={{
                  fontSize: '0.78rem',
                  color: 'rgba(255,255,255,0.55)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                }}
              >
                {stat.label}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};
